export const isPasswordValid = (value) => {
  const minLength = 8;

  if (!value || value.length < minLength) {
    return `La password deve essere lunga almeno ${minLength} caratteri`;
  }
};

export const isInteger = (value) => {
  if (value && !Number.isInteger(parseInt(value, 10))) {
    return 'Questo valore dovrebbe essere un numero intero';
  }
};

export const isEmail = (value) => {
  const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

  if (re.test(String(value).toLowerCase()) === false) {
    return 'Questo valore non è un indirizzo e-mail valido';
  }
};

export const isRequired = (value) => (
  (!value || value.length === 0)
        && value !== false
        && value !== 0
        && 'Questo valore non dovrebbe essere vuoto'
);

export const isEditorRequired = (value) => (
  (!value || (value && value.trim() === '<p></p>'))
        && 'Questo valore non dovrebbe essere vuoto'
);

export const isCoordinatesRequired = (value) => (
  (!value || !value.longitudine || !value.latitudine)
        && 'È necessario impostare una posizione sulla mappa'
);

export const isLengthRequired = (length) => (value) => (
  (!value || value.length !== length)
        && `Questo valore deve essere lungo ${length} caratteri`
);

export const mapLocationErrorResponseToData = (errors) => {
  const destinationError = Object.keys(errors)
    .filter((key) => /^destinazioni\[[0-9]+\]$/.test(key))
    .reduce((memo, key) => `${memo}${memo && ','} ${errors[key]}`, '');

  const genericDescriptionError = errors.descrizioneGenerica && errors.descrizioneGenerica[0];

  const coordinatesError = (errors.latitudine && errors.latitudine[0])
        || (errors.longitudine && errors.longitudine[0]);
  return {
    ...errors,
    destinazioni: destinationError,
    descrizione: {
      descrizioneGenerica: genericDescriptionError,
    },
    coordinate: coordinatesError,
  };
};

export const mapDestinationErrorResponseToData = (errors) => ({
  ...errors,
  nome: errors.nome && errors.nome[0],
  descrizione: errors.descrizione && errors.descrizione[0],
});

export const isRequiredIVA = (value, values) => {
  const required = values.nazione !== 'IT' && values.nazione;

  return (
    required
        && (!value || value.length === 0)
        && 'Questo valore non dovrebbe essere vuoto'
  );
};

export const isRequiredProvince = (value, values) => {
  const required = values.nazioneLegale === 'IT';

  return (
    required
        && (!value || value.length === 0)
        && 'Questo valore non dovrebbe essere vuoto'
  );
};

export const isRequiredActivity = (value) => {
  let flag = false;
  const errors = [];

  value
    && value.forEach((entry, index) => {
      errors[index] = {};
      if (!entry.nome || entry.nome === '') {
        errors[index].nome = 'Questo valore non dovrebbe essere vuoto';
        flag = true;
      }

      if (!entry.localita || entry.localita === '') {
        errors[index].localita = 'Questo valore non dovrebbe essere vuoto';
        flag = true;
      }
    });

  if (flag) {
    return errors;
  }

  return undefined;
};

export const isRequiredArray = (value) => {
  if (!value || value.length === 0) {
    return 'Questo valore non dovrebbe essere vuoto';
  }

  if (value?.includes(undefined) || value?.includes('')) {
    return 'Non dovrebbero esserci valori vuoti';
  }

  return undefined;
};
